<template>
    <DFabs v-if="batchMode === false">
        <DFab
            id="tasks-export-csv"
            icon="download"
            :label="__('tasks.export.button')"
            @click="clickExport"
        />
        <DFab
            icon="checkbox-multiple-marked"
            :label="__('tasks.batch-mode.start')"
            @click="clickStart"
        />
    </DFabs>
    <DFabs v-else>
        <DFab
            icon="content-save"
            :disabled="batchTaskCount === 0"
            :label="__('tasks.batch-mode.save', {tasks: batchTaskCount})"
            @click="clickSave"
        />
        <DFab
            icon="close-circle"
            :label="__('tasks.batch-mode.cancel')"
            @click="clickCancel"
        />
    </DFabs>
</template>

<script setup>
import { ref } from 'vue'

const batchMode = ref(false)
const emit = defineEmits(['start-batch-mode', 'stop-batch-mode', 'save', 'export'])
defineProps({
    batchTaskCount: {
        type: Number,
        default: 0
    }
})

const clickCancel = () => {
    batchMode.value = false
    emit('start-batch-mode')
}
const clickSave = () => {
    batchMode.value = false
    emit('save')
}
const clickStart = () => {
    batchMode.value = true
    emit('start-batch-mode')
}
const clickExport = () => {
    emit('export')
}

</script>
